import { useEffect, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import ModalAddStaff from "./ModalAddStaff";
import StaffCollapsible from "./StaffCollapsible";

const AddRegisterStaff = ({
  formik,
  dataTitle,
  isFetchingTitle,
  dataRole,
  isFetchingRole,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [collapseArr, setCollapseArr] = useState([]);

  useEffect(() => {
    setCollapseArr([...Array(formik.values.staff.length).fill(false)]);
  }, [formik.values.staff]);

  return (
    <div>
      <button
        type="button"
        className="w-full bg-blue-500 text-white hover:bg-gray-300 !rounded-md flex items-center gap-2 justify-center p-2 mb-4"
        onClick={() => {
          setSelectedIndex(-1);
          setOpenModal(true);
        }}
      >
        <IoIosAddCircleOutline />
        Tambah Staff
      </button>
      {formik.values.staff.length === 0 ? (
        <p className="w-full text-center">
          Tidak ada staff, silahkan tambahan staff baru
        </p>
      ) : (
        <div className="w-full">
          {formik.values.staff.map((item, i) => (
            <StaffCollapsible
              collapseArr={collapseArr}
              setCollapseArr={setCollapseArr}
              formik={formik}
              dataTitle={dataTitle}
              dataRole={dataRole}
              item={item}
              i={i}
              setSelectedIndex={setSelectedIndex}
              setOpenModal={setOpenModal}
            />
          ))}
        </div>
      )}

      <ModalAddStaff
        formik={formik}
        open={openModal}
        setOpen={setOpenModal}
        index={selectedIndex}
        dataTitle={dataTitle}
        isFetchingTitle={isFetchingTitle}
        dataRole={dataRole}
        isFetchingRole={isFetchingRole}
      />
    </div>
  );
};
export default AddRegisterStaff;
